import Money from './../Money';

export default class Invoice {
  private readonly _id: string;
  private readonly _number: string;
  private readonly _fileName: string;
  private readonly _status: string;
  private readonly _orderReference: string;
  private readonly _dateOpened: Date|null;
  private readonly _total: Money;
  private readonly _links: object;
  constructor({
        id,
        number,
        fileName,
        status,
        orderReference,
        dateOpened,
        total,
        links,
      }) {
    this._id = id;
    this._number = number;
    this._fileName = fileName;
    this._status = status;
    this._orderReference = orderReference;
    this._dateOpened = dateOpened ? new Date(dateOpened) : null;
    this._total = new Money(total);
    this._links = links;
  }

  get id(): string {
    return this._id;
  }

  get number(): string {
    return this._number;
  }

  get fileName(): string {
    return this._fileName;
  }

  get status(): string {
    return this._status;
  }

  get orderReference(): string {
    return this._orderReference;
  }

  get dateOpened(): Date | null {
    return this._dateOpened;
  }

  get total(): Money {
    return this._total;
  }

  get links(): object {
    return this._links;
  }

  isOpen() {
      return this._status === 'open';
  }

  isPaid() {
    return this._status === 'paid';
  }
}
